(() => {
  const root = document.documentElement;
  const storageKey = 'gara-color-mode';
  let transition;

  const syncButtons = () => {
    const dark = root.dataset.garaMode !== 'light';
    document.querySelectorAll('.gk-theme-toggle').forEach((button) => {
      button.setAttribute('aria-checked', String(dark));
      button.title = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
    });
  };

  const apply = (mode) => {
    root.dataset.garaMode = mode;
    syncButtons();
  };

  const restore = () => {
    try {
      apply(localStorage.getItem(storageKey) === 'light' ? 'light' : 'dark');
    } catch {
      syncButtons();
    }
  };

  const toggle = () => {
    transition?.skipTransition();
    const mode = root.dataset.garaMode === 'light' ? 'dark' : 'light';
    try {
      localStorage.setItem(storageKey, mode);
    } catch {}
    if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      transition = document.startViewTransition(() => apply(mode));
      transition.finished.catch(() => {});
    } else {
      apply(mode);
    }
  };

  if (!customElements.get('gara-theme-toggle')) {
    customElements.define('gara-theme-toggle', class extends HTMLElement {
      connectedCallback() {
        this.hidden = false;
        this.addEventListener('click', toggle);
        syncButtons();
      }

      disconnectedCallback() {
        this.removeEventListener('click', toggle);
      }
    });
  }

  window.addEventListener('pageshow', restore);
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey || event.key === null) restore();
  });
  syncButtons();
})();
